export const SupportHistoryEditDialogTitle = {
  add: '対応履歴新規登録',
  update: '対応履歴編集',
};
